import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Wrap from './pages/wrap';
import Claim from './pages/claim';
import Status from './pages/status';
import Popup from './components/popup';
import Home from './pages/home';
import { useState } from 'react';
function App() {
  const [metamask_trigger, set_metamask_trigger] = useState(false);
  const [address, set_address] = useState("");
  const [cosmos_address, set_cosmos_address] = useState("");
  return (
    <Router >
     <Navbar trigger={metamask_trigger} set_trigger={set_metamask_trigger} address={address} cosmos_address={cosmos_address}/>
     <Popup trigger={metamask_trigger} set_trigger={set_metamask_trigger} set_address={set_address} set_cosmos_address={set_cosmos_address}/>
     <Routes>
       <Route path="/" exact element={<Home/>} />
       <Route path="/claim" element={<Claim/>} />
       <Route path="/status" element={<Status/>} />
       <Route path="/wrap" element={<Wrap cosmos_address={cosmos_address} address={address}/>}  />
     </Routes>
    </Router>
    
  );
}

export default App;
